import {
    GET_LOG_LOADING,
    GET_LOG_SUCCESS,
    GET_LOG_REJECT,
} from "../../actions/log/getAll";

import {
    GET_LOG_FILTER_LOADING,
    GET_LOG_FILTER_SUCCESS,
    GET_LOG_FILTER_REJECT,
} from "../../actions/log/getAllFilterLogs";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    optionScreen: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    }
}

const logReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_LOG_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_LOG_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_LOG_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET ALL OPTION SCREEN--------------------
        case GET_LOG_FILTER_LOADING: return {
            ...state,
            optionScreen: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_LOG_FILTER_SUCCESS: return {
            ...state,
            optionScreen : {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_LOG_FILTER_REJECT: return {
            ...state,
            optionScreen: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        default: return state;
    }
}

export default logReducer